// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 1091 ? "4b55bd4f" : chunkId) + "." + {"1091":"9158d25fd7c367e5","2204":"ae97209854e479a1"}[chunkId] + ".js";
};